/* INKED3 - final fix. The closed "sub description" tabs are built by the Vitals Product Tabs
   app after page load. On a color change the theme's variant update overwrites the description
   HTML, destroying the app-built tabs (shows raw expanded text). This patch removes the
   description from the INCOMING update before the theme's replace logic runs, so the current
   tabbed description is never touched and nothing can be duplicated. */
(function () {
  function patch() {
    var PI = customElements.get('product-information');
    if (!PI) return false;
    if (PI.__inked3DescPatched) return true;
    var orig = PI.prototype.replaceElements;
    PI.prototype.replaceElements = function (html, context) {
      try {
        if (html) {
          html.querySelectorAll('[data-update-id]').forEach(function (el) {
            if (el.classList && el.classList.contains('product-description')) {
              el.remove();
            }
          });
        }
      } catch (e) { /* never block the theme's own update */ }
      return orig.call(this, html, context);
    };
    PI.__inked3DescPatched = true;
    return true;
  }
  if (!patch()) {
    var t = setInterval(function () { if (patch()) clearInterval(t); }, 100);
    setTimeout(function () { clearInterval(t); }, 10000);
  }
})();